import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Welcome To PaEcom',
  description: 'Welcome to PaEcom – Your one-stop destination for quality electronics at unbeatable prices. Explore a diverse range of products and shop with confidence for the best deals.',
  keywords: 'electronics, buy electronics, cheap electronics, online shopping, affordable gadgets, tech deals, electronic accessories, budget-friendly electronics',
};

export default Meta;

// slogan: 
